<h5 *ngIf="attiSuggeriti && attiSuggeriti.length > 0">Atti suggeriti:</h5>
<h5 *ngIf="!attiSuggeriti || attiSuggeriti.length == 0">Nessun atto suggerito</h5>
<div class="row">
  <app-atti-list-view
    [hasDeleteButton]="true"
    [hasAssociaButton]="true"
    [atti]=attiSuggeriti
    [associaDisabled]="isEdit"
    (saveNewAttoEvent)="onSave($event)"
    (associaEvent)="associa($event)">
  </app-atti-list-view>
  <div>
    <div class="container_tab_nav">
      <ul class="nav nav-tabs two">

        <li
          class="{{!isShowForm ? 'active' : 'inactive'}}"
          (click)="onShowList()"
          style="width: 50%;">
          <a data-toggle="tab" aria-expanded="true">Lista atti inseriti</a>
        </li>

        <li
          class="{{isShowForm ? 'active' : 'inactive'}}"
          (click)="onFormAtto()"
          style="width: 50%;">
          <a data-toggle="tab" aria-expanded="true">Crea nuovo atto</a>
        </li>

      </ul>

      <div class="tab-content">
        <div [hidden]="!isShowForm">
          <div class="tab-pane fade active in">
            <app-step-atti-form
            [attoAssociato]="attoAssociato"
            [attoToEdit]="attoToEdit"
            (sendAttoEvent)="onSave($event)"
            (showListEvent)="annullaModifica()"
            (pulisciCampiEvent)="pulisciCampi()"
            >
          </app-step-atti-form>
          </div>
        </div>
        <div [hidden]="isShowForm">
          <div class="tab-pane fade active in">
            <app-atti-list-view
            [hasDeleteButton]="true"
            [hasEditButton]="true"
            [atti]=atti
            (deleteEvent)="deleteAtto($event)"
            (editEvent)="editAtto($event)">
          </app-atti-list-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row wizard-buttons">
  <p class="col-sm-3 col-xs-6">
    <button type="button" class="btn btn-outline-secondary btn-block" (click)="reset()">Reset</button>
  </p>
  <p class="col-sm-3 col-xs-6 col-sm-offset-6">
    <button type='button' class='btn btn-primary btn-block' (click)="prosegui()">
      Prosegui
    </button>
  </p>
</div>
<div #bottom></div>
